import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, Signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CalculatePriceRequest, CalculatePriceResponse, EstadoGuia, GetGuiaListResponse, GetGuiasEnSucursalList, GuiaDetalleDTO, GuiaDTO, ServicioDTO, TrackingInformationDTO } from '../../../shared/models/generated';

@Injectable({
  providedIn: 'root'
})
export class GuiasService {
  
  export(estados: EstadoGuia[]) {
    return this.http.get(`${environment.apiUrl}/api/guias/export`, { params: { estados: estados }, headers: { 'Accept': 'text/csv' }, responseType: 'blob', observe: 'events', reportProgress: true });
  }
  cancel(guiaId: number) {
    return this.http.post(`${environment.apiUrl}/api/guias/${guiaId}/cancel`, {});
  }
  updateState(tracking: number, estadoGuiaId: number, sucursalId: number) {
    return this.http.post(`${environment.apiUrl}/api/guias/update-state?trackingNumber=${tracking}`, { estadoId: estadoGuiaId, sucursalId });
  }
  printGuia(guiaId: number) {
    return this.http.post(`${environment.apiUrl}/api/guias/${guiaId}/print-guia`, {});
  }
  printEtiqueta(guiaId: number) {
    return this.http.post(`${environment.apiUrl}/api/guias/${guiaId}/print-etiqueta`, {});
  }
  delete(id: number | undefined) {
    return this.http.delete(`${environment.apiUrl}/api/guias/${id}`);
  }
  constructor(private http: HttpClient) { }
  update(dto: GuiaDTO | undefined, printEtiqueta: boolean, printAllGuias: boolean) {
    return this.http.put(`${environment.apiUrl}/api/guias?printEtiqueta=${printEtiqueta}&printAllGuias=${printAllGuias}`, dto);
  }
  insert(dto: GuiaDTO | undefined, printEtiqueta: boolean, printAllGuias: boolean) {
    return this.http.post(`${environment.apiUrl}/api/guias?printEtiqueta=${printEtiqueta}&printAllGuias=${printAllGuias}`, dto);
  }
  calculatePrices(dto: CalculatePriceRequest[]) {
    return this.http.post<CalculatePriceResponse[]>(`${environment.apiUrl}/api/guias/calculate-prices`, dto);
  }

  resources = {
    get: (id: Signal<number | undefined>, defaultValue: GuiaDTO|undefined= undefined) => {
      return httpResource<GuiaDTO>(() => {
        const guiaId = id(); // Set breakpoint here
        console.log("guiaid", guiaId);
        if (guiaId == 0) {
          return undefined;
        }

        return {
          url: `${environment.apiUrl}/api/guias/${guiaId}`,

        };
      }, {
        defaultValue: defaultValue ?? { detalles: [] as GuiaDetalleDTO[], retiraEnDomicilio: false, retiraEnSucursal: false } as GuiaDTO,
      });
    },
    getByTrackingNumber: (id: Signal<number | undefined>) => httpResource<GuiaDTO>(() => id() ? { url: `${environment.apiUrl}/api/guias/tracking/${id()}` } : undefined, { defaultValue: undefined } as any),
    getTrackingInformation: (id: Signal<number | undefined>) => httpResource<TrackingInformationDTO>(() => id() ? { url: `${environment.apiUrl}/api/tracking/${id()}` } : undefined, { defaultValue: undefined } as any),
    getList: (estadosIds: Signal<string[] | undefined>) => httpResource<GetGuiaListResponse[]>(() => (estadosIds() && estadosIds()!.length > 0 ? { url: `${environment.apiUrl}/api/guias`, params: { estados: estadosIds()! } } : undefined)),
    getGuiasParaReparto: (id: Signal<number | undefined>) => httpResource<GetGuiasEnSucursalList[]>(() => id() ? { url: `${environment.apiUrl}/api/repartos/${id()}/guias` } : { url: `${environment.apiUrl}/api/guias/en-mi-sucursal` }),
    getGuiasAAsignarCount: () => httpResource<number>(() => ({ url: `${environment.apiUrl}/api/guias/en-mi-sucursal/cantidad` })),

    getServicio: (id: Signal<number>) => httpResource<ServicioDTO>(() => ({ url: `${environment.apiUrl}/api/guias/${id()}/servicio` })),
    calculatePrice: (guia: Signal<CalculatePriceRequest | undefined>) => httpResource<CalculatePriceResponse>(() => guia() ? { url: `${environment.apiUrl}/api/guias/calculate-price`, body: guia(), method: 'POST' } : undefined),
  }
}
